<template>
  <footer class="footer">
    <div class="container">
      <div class="copyright text-center">
        &copy; <b>Губернский колодезь</b>, {{ new Date().getFullYear() }}
        <br />
        разработка:
        <a
          href="https://github.com/AVShatokhin?tab=repositories"
          target="_blank"
          >AVShatokhin</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.container {
  justify-content: center;
}
</style>
